<template>
  <div class="editor-select-container">
    <div v-if="label" class="editor-select-label">{{ label }}</div>
    <el-select
      :value="value"
      :placeholder="placeholder"
      v-bind="$attrs"
      v-on="$listeners"
      popper-class="editor-select-popper"
      :loading="isLoading"
      :remote-method="dealWithRemoteRequest"
      @change="handleChange"
    >
      <el-option
        v-for="(item, index) in selectOptions"
        :key="index"
        :label="item[keyLabel]"
        :value="item[keyValue]"
      >
        <p
          v-if="item.highlight"
          v-html="item.highlight"
        ></p>
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'EditorSelect',
  components: {},
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      // 支持多选时设置为数组
      type: [String, Number, Array],
      default: '',
    },
    keyLabel: {
      type: String,
      default: 'label',
    },
    keyValue: {
      type: String,
      default: 'value',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    remoteMethodCallback: {
      type: [Function, Boolean],
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      selectOptions: this.options,
    };
  },
  watch: {
    options: {
      handler(newVal) {
        this.selectOptions = newVal;
      },
      deep: true,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  methods: {
    async dealWithRemoteRequest(query) {
      if (!this.remoteMethodCallback) return;
      try {
        this.isLoading = true;
        this.selectOptions = [];
        const res = await this.remoteMethodCallback(query);
        if (res.code === 1000) {
          this.selectOptions =
            res.data?.map((item) => ({
              ...(item || {}),
              label: item.name,
              value: item.id,
            })) || [];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.editor-select-container {
  display: flex;
  flex-direction: column;
  .editor-select-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .el-select {
    ::v-deep(.el-input__inner) {
      border-color: transparent !important;
      background-color: $page-bg-sub-color;
      color: $text-color;
      &:focus,
      &:hover {
        border-color: transparent !important;
      }
      &::placeholder {
        color: $placeholder-color;
      }
    }
  }
}
</style>
<style lang="scss">
@import '@/assets/css/variable.scss';
.editor-select-popper {
  background-color: transparent !important;
  border-color: $select-border-color !important;
  background: linear-gradient(45deg, $select-bg-start-color 0%, $select-bg-middle-color 62%, $select-bg-end-color 100%);
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-select-dropdown__list {
        .el-select-dropdown__item {
          color: $text-color;
          .es-highlighter {
            color: $theme-color;
          }
          &.hover,
          &:hover {
            background-color: $select-dropdown-item-hover;
          }
        }
      }
    }
  }
  .popper__arrow {
    display: none;
  }
}
</style>
